import LargePopup from 'components/popup/large-popup';
import React from 'react';
import styled from 'styled-components';
import { COLOR } from 'constants/colors';
import { SuccessButton, SuccessButtonWhiteBg } from 'components/button';
import { useMediaQuery } from 'react-responsive';
import { useForm } from 'react-hook-form';
import { getUserDetails } from '__utils/storage';
import useFlashToggler from 'hooks/use-flash-toggler';
import { CommonStyledComponentProps } from '__utils/type';
import callBtn from "images/call-expert.svg";
import { isBtoCFlow, isMintproApp, isProUser } from '__utils/common-utils';

const PaymentOTPVerificationOuterCont = styled.div<CommonStyledComponentProps>`
    background-color: ${COLOR.WHITE};
    padding: ${(props: CommonStyledComponentProps) => props.isMobile ? isProUser() ? `16px` : `48px 16px 16px 16px` : ``};
    height: ${(props: CommonStyledComponentProps) => props.isMobile ? `calc(100vh - 58px)` : `auto`};
    
    .greenUnderlinedTxt{
        color: ${COLOR.GREEN} !important;
        text-decoration: underline !important;
        cursor: pointer;
    }
    .otpText{
        color: darkgrey;
        line-height: 1.5; 
    }

    .w-120{
        width: 120px
    }
`;

interface PaymentOtpVerificationProps {
    onClose?: any;
    onVerifyOtp: (otp: number) => void;
    onResendOtp: () => void;
    highRiskWarning: boolean;
}

const PaymentOtpVerification: React.FC<PaymentOtpVerificationProps> = (props: PaymentOtpVerificationProps) => {

    const isMobile = useMediaQuery({ maxWidth: 767 });
    const flash = useFlashToggler();
    const { register, handleSubmit } = useForm({ mode: 'onChange' });
    const TermsLink = isMobile ? 'https://drive.google.com/viewerng/viewer?embedded=true&url=https://docs.turtlemintmoney.com/docs/SelfDeclaration.pdf'
        : 'https://docs.turtlemintmoney.com/docs/SelfDeclaration.pdf';
        
    const onVerifyOtpSubmit = (data: any) => {
        if (!data.otp)
        {
            flash.error("Please enter OTP.");
            
        } else if (data.otp?.length !== 6)
        {
            flash.error("Please enter correct OTP.");

        } else
        {
            props.onVerifyOtp(data.otp);
        }
    }
    const redirectToTnC = () =>{
        if (isMintproApp())
        {
            var featurePayload = {
                type: 'chromeTab',
                payload: {
                    url: TermsLink
                },
            };
            window.postMessage(JSON.stringify(featurePayload), '*');
        }
        else
            window.open(TermsLink, '_blank','noopener')?.focus();  
    }

    return <LargePopup
        modalWidth='520px'
        closable={ false }
        showBacktoHome
        headerContent={
            <div style={ { fontSize: "16px", display: 'flex', justifyContent: 'space-between', alignItems: 'center' } }>
                <div>
                    <i className="icon-Back headerIconSet" style={ { fontSize: "22px", marginRight: "10px", lineHeight: "1.5" } }
                        onClick={ () => props?.onClose() }>
                    </i>
                    <span style={ { lineHeight: "2.1", fontSize: "16px" } }>Payment Verification
                    </span>
                </div>
                <div>
                    <a href="tel:18002666468" style={ { marginRight: '6px' } }><img src={ callBtn } alt="call expert" /></a>

                </div>
            </div> }>

        <PaymentOTPVerificationOuterCont isMobile={ isMobile }>
            <section>
                { !isMobile && <h3 className="class-h3">Payment Verification</h3> }
                { <div className={ isMobile ? "mint-box mt15 mb16 p16" : "" } style={ { padding: "16px" } }>
                    <div className="otpText">
                        { props?.highRiskWarning && <> <div>{ isBtoCFlow() ? 'You are' :  'Your Customer is' } willing to invest in a higher risk profile than the assessed risk profile</div><br /></> }
                        <div>A One Time Password (OTP) has been sent to { isBtoCFlow() ? "your" :  "your customer's" } email ID (<span style={ { color: "black" } }>{ getUserDetails()?.primaryEmail }</span>) and phone number (<span style={ { color: "black" } }>{ getUserDetails()?.primaryMobile }</span>). Kindly enter the OTP below.</div>
                        <br />
                        <div style={ { marginBottom: "30px" } }> Terms and Conditions - <a className="greenUnderlinedTxt" onClick={ redirectToTnC }>here</a></div>
                    </div>
                    <form name="paymentVerificationForm" onSubmit={ handleSubmit(onVerifyOtpSubmit) }>
                        <div style={ { marginTop: "10px", marginBottom: "24px" } } >
                            <div style={ { fontSize: "13px" } }>6 digit OTP</div><br />
                            <input
                                name='otp'
                                type="number"
                                placeholder="******"
                                ref={register({ required: "Please enter OTP." }) }
                            />
                        </div>
                        <div style={ { textAlign: "right" } }>
                            <SuccessButtonWhiteBg className='w-120' type="button" onClick={ props.onResendOtp }>Resend OTP</SuccessButtonWhiteBg>
                            <SuccessButton className='w-120' type="submit" >Verify OTP</SuccessButton>
                        </div>
                    </form>
                </div> }
            </section>
        </PaymentOTPVerificationOuterCont>
    </LargePopup>
}

export default PaymentOtpVerification;